
import axiosInstance from "@/api/axiosInstance";
import type { CustomerFormData } from "@/schemas/customer.schema";


interface CreateCustomerResponse {
    success: boolean;
    message: string;
    data?: any;
}

interface UpdateCustomerResponse {
    success: boolean;
    message: string;
    data?: any;
}

interface DeleteCustomerResponse {
    success: boolean;
    message: string;
}
// Create Customer
export const createCustomer = async (
    email: string,
    data: CustomerFormData
): Promise<CreateCustomerResponse> => {
    try {
        const response = await axiosInstance.post<CreateCustomerResponse>(
            `/kasir/create-customer?email=${email}`,
            {
                cust_name: data.cust_name,
                cust_nik: Number(data.cust_nik),
                cust_address: data.cust_address,
                cust_email: data.cust_email || "",
                cust_phone: data.cust_phone,
            }
        );

        if (response.data.success) {
            return response.data;
        }

        throw new Error(response.data.message || "Gagal membuat customer");
    } catch (error) {
        console.error("createCustomer error:", error);
        throw error;
    }
};

// Update Customer
export const updateCustomer = async (
    email: string,
    custId: number,
    data: CustomerFormData
): Promise<UpdateCustomerResponse> => {
    try {
        const response = await axiosInstance.put<UpdateCustomerResponse>(
            `/kasir/update-customer?email=${email}&cust_id=${custId}`,
            {
                cust_name: data.cust_name,
                cust_nik: Number(data.cust_nik),
                cust_address: data.cust_address,
                cust_email: data.cust_email || "",
                cust_phone: data.cust_phone,
            }
        );

        if (response.data.success) {
            return response.data;
        }

        throw new Error(response.data.message || "Gagal update customer");
    } catch (error) {
        console.error("updateCustomer error:", error);
        throw error;
    }
};


export const deleteCustomer = async (
    email: string,
    custId: number
): Promise<DeleteCustomerResponse> => {
    try {
        const response = await axiosInstance.delete<DeleteCustomerResponse>(
            `/kasir/delete-customer?email=${email}&cust_id=${custId}`
        );

        if (response.data.success) {
            return response.data;
        }

        throw new Error(response.data.message || "Gagal menghapus customer");
    } catch (error) {
        console.error("deleteCustomer error:", error);
        throw error;
    }
};